import { render, staticRenderFns } from "./FaqAnswerDepartment.vue?vue&type=template&id=36e15493&scoped=true&"
import script from "./FaqAnswerDepartment.vue?vue&type=script&lang=js&"
export * from "./FaqAnswerDepartment.vue?vue&type=script&lang=js&"
import style0 from "./FaqAnswerDepartment.vue?vue&type=style&index=0&id=36e15493&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e15493",
  null
  
)

export default component.exports